import { NegativeThumb, PositiveThumb } from '../../assets/icons';

const REVIEW_LABELS = {
  positive: 'Avis positif',
  performance: 'Performance',
  professionalism: 'Professionalisme',
};

const getReviewLabel = (review) => {
  if (review?.type === 'positive') return REVIEW_LABELS.positive;
  return REVIEW_LABELS[review?.type_negative] || '';
};

const ReviewCard = ({ review }) => (
  <div className="border rounded-lg p-4">
    <div className="flex flex-col gap-6">
      <div className="flex justify-between gap-3">
        <div>
          <div>{getReviewLabel(review)}</div>
          <div className="text-gray-500">{review?.comment}</div>
        </div>
        <div className="my-auto w-fit rounded-full p-2" style={{ backgroundColor: review?.type === 'positive' ? '#F0FDF4' : '#FEF2F2' }}>
          {review?.type === 'positive'
            ? <PositiveThumb wh={20} color="#10B981" />
            : <NegativeThumb wh={24} color="#EF4444" />
          }
        </div>
      </div>
      <div className="flex justify-between gap-3">
        <div className="my-auto text-gray-500">
          Par {review?.employee?.firstname} {review?.employee?.lastname}
        </div>
        <div className="my-auto">
          {review?.mission?.title} n°{review?.mission?.id_mission}
        </div>
      </div>
    </div>
  </div>
);

export { getReviewLabel, REVIEW_LABELS };
export default ReviewCard;
